import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { goBack, push } from "connected-react-router";
import gaEventTracker, { events } from "util/gaEventTracker";
import Head from "pages/_components/Head";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import classNames from "classnames";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import { bool, func, shape, string } from "prop-types";
import { actions as enrollmentActions, selectors as enrollmentSelectors } from "reducers/enrollment";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";
// import { actions as actionSoftToken } from "reducers/softToken";
import { Grid } from "react-bootstrap";
import ErrorPopup from "../_components/ErrorPopup";
import Stepper from "../_components/Stepper";

const PAGE_ID = "StepSelectSecuritySeal";

const StepSelectSecuritySeal = ({
    dispatch,
    isMobile,
    securitySeals,
    currentSecuritySealId,
    fetching,
    exchangeToken,

    password,
    passwordConfirmation,
    username,
    documentData,
    documentType,
    email,
    mobileNumber,
    userCreationStatus,
    fetchingUserCreation,

    onboardingWithInvitation,
    signer,
}) => {
    const [isValidating, setIsValidating] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        dispatch(enrollmentActions.requestSecuritySeals());
    }, []);

    useEffect(() => {
        if (isValidating && userCreationStatus && userCreationStatus === "SUCCESS") {
            setIsValidating(false);
            // dispatch(actionSoftToken.getDeviceSee(exchangeToken));
            dispatch(push("/onboarding/stepUserFinish"));
            dispatch(modalActions.modalClose());
        } else if (isValidating && userCreationStatus?.length) {
            setIsValidating(false);
            setError(userCreationStatus);
            dispatch(modalActions.modalShow());
        }
    }, [isValidating, userCreationStatus]);

    const handleClick = (id) => {
        dispatch(enrollmentActions.changeSecuritySealConfirmationPre(id));
    };

    const submitUser = () => {
        setIsValidating(true);
        dispatch(
            enrollmentActions.changeSecuritySealConfirmation(
                currentSecuritySealId,
                securitySeals[currentSecuritySealId],
            ),
        );
        if (onboardingWithInvitation === null) {
            gaEventTracker.triggerEvent(events.registry9);
        }

        dispatch(
            onboardingActions.createUser(
                {
                    _password: password,
                    _passwordConfirmation: passwordConfirmation,
                    _securitySeal: currentSecuritySealId,
                    _userConfirmation: username,
                    personalData: {
                        firstName: documentData?.firstName,
                        lastName: documentData?.lastName,
                        productGroupId: null,
                        email,
                        idEnvironment: "11",
                    },
                    phone: mobileNumber,
                    document: documentData?.documentNumber,
                    documentType,
                    gender: documentData?.gender,
                    guestFlow: !!onboardingWithInvitation,
                    signer,
                },
                exchangeToken,
            ),
        );
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const isSealSelected = (id) => id === `${currentSecuritySealId}`;

    return (
        <Fragment>
            {isMobile && <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} hideNavbarInMobile />}
            <MainContainer showLoader={fetching}>
                <Stepper isMobile={isMobile} page={PAGE_ID} />
                <h1 className="text-center" style={{ textAlign: "left" }}>
                    <I18n id="onboarding.securitySeal.title" defaultValue="Elegí una imagen de seguridad" />
                </h1>
                <I18n
                    id="onboarding.securitySeal.description"
                    defaultValue="Vas a tener que recordarla al momento de ingresar a Bibank."
                />

                <div className="container--layout items-center">
                    <Grid className="form-content">
                        <Row className="justify-content-center">
                            <Col sm={12} className="col-12 image-grid">
                                <Row>
                                    {Object.entries(securitySeals).map(([id, securitySeal]) => (
                                        <Col
                                            sm={3}
                                            md={3}
                                            className={classNames("col-6", { "is-current": isSealSelected(id) })}
                                            key={`securitySeal-${id}`}>
                                            <Button
                                                className={classNames("btn-image btn-image-seal", {
                                                    "is-current": isSealSelected(id),
                                                })}
                                                id={id}
                                                label=""
                                                onClick={() => handleClick(id)}
                                                style={{
                                                    backgroundImage: `url(${securitySeal})`,
                                                    width: "4rem",
                                                    height: "4rem",
                                                }}
                                                block
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </Grid>
                </div>
                <div className="form-actions">
                    <Button
                        bsStyle="primary"
                        label="global.continue"
                        loading={fetching || isValidating || fetchingUserCreation}
                        onClick={submitUser}
                        disabled={!currentSecuritySealId}
                        block
                    />
                </div>
            </MainContainer>
            <ErrorPopup
                error={error}
                handleClick={() => {
                    dispatch(modalActions.modalClose());
                }}
            />
        </Fragment>
    );
};

StepSelectSecuritySeal.propTypes = {
    isMobile: bool.isRequired,
    currentSecuritySealId: string,
    dispatch: func.isRequired,
    fetching: bool.isRequired,
    exchangeToken: string.isRequired,
    securitySeals: shape({}).isRequired,

    password: string,
    passwordConfirmation: string,
    username: string,
    documentData: shape({}),
    documentType: string,
    email: string,
    mobileNumber: string,

    userCreationStatus: string,
    fetchingUserCreation: bool.isRequired,

    onboardingWithInvitation: bool.isRequired,
    signer: shape({}).isRequired,
};

StepSelectSecuritySeal.defaultProps = {
    currentSecuritySealId: "",

    password: "",
    passwordConfirmation: "",
    username: "",
    documentData: {},
    documentType: "",
    email: "",
    mobileNumber: "",

    userCreationStatus: "",
};

const mapStateToProps = (state) => ({
    securitySeals: enrollmentSelectors.getSecuritySeals(state),
    fetching: enrollmentSelectors.getFetching(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    currentSecuritySealId: enrollmentSelectors.getSelectedSecuritySealId(state),
    fetchingUserCreation: onboardingSelectors.getFetching(state),
    userCreationStatus: onboardingSelectors.getUserCreationStatus(state),
    password: onboardingSelectors.getPassword(state),
    passwordConfirmation: onboardingSelectors.getPasswordConfirmation(state),
    username: onboardingSelectors.getUsername(state),
    documentData: onboardingSelectors.getDocumentData(state),
    documentType: onboardingSelectors.getDocumentType(state),
    email: onboardingSelectors.getEmail(state),
    mobileNumber: onboardingSelectors.getMobileNumber(state),
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    signer: onboardingSelectors.getInvitationData(state),
});
export default connect(mapStateToProps)(StepSelectSecuritySeal);
// export default compose(connect(mapStateToProps))(withExchangeToken(StepSelectSecuritySeal));
